module.exports = __webpack_public_path__ + "img/mitsu03.f780ff00.png";